import React from "react";
import Label from "../atoms/Label";

export default ({ name, extention, onChange, loading, files, done }) => {
	return (
		<div className="d-flex justify-content-start align-items-center">
			<div className="form-content mr-2">
				<label className="btn-kc btn-kc-img btn-kc-yellow m-0" htmlFor={`upload-${name}`} style={!loading ? { cursor: "pointer" } : { cursor: "not-allowed" }}>
					<img alt="Upload" src="/img/icon/icon-upload.png" />
				</label>

				<input
					type="file"
					name={name}
					disabled={loading ? true : false}
					id={`upload-${name}`}
					accept={extention || ".png,.jpg,.jpeg"}
					style={{ display: "none" }}
					onChange={(file) => {
						onChange(name, file.target.files[0]);
					}}
				/>
			</div>

			{loading ? (
				<div className="d-flex align-items-center">
					<span className="spinner-border spinner-border-sm text-secondary"></span>
					<Label className="ml-1" value="Mengunggah..." />
				</div>
			) : done ? (
				<label className="label-kc green ">{done}</label>
			) : (
				files &&
				(typeof files == "string" ? (
					//file is link 'string'
					<a href={files} target="_blank">
						<label className="label-kc blue link">Lihat Data</label>
					</a>
				) : (
					//file is function
					<label onClick={() => files(name)} className="label-kc blue link">
						Lihat Data
					</label>
				))
			)}
		</div>
	);
};
